import React, { useState, useEffect } from 'react';
import { Container, Typography } from '@mui/material';
import searchDescriptionService from '../services/searchDescriptionService';
import { useMeta } from '../contexts/MetaContext';

const SearchDescription = ({ collections, brands }) => {
  const [searchDescription, setSearchDescription] = useState(null);
  const { metaData } = useMeta();

  useEffect(() => {
    const description = searchDescriptionService.getSearchDescription(collections, brands, metaData);
    setSearchDescription(description);
  }, [collections, brands, metaData]);


  // Only render if we have a search description match
  if (!searchDescription) {
    return null;
  }

  return (
    <Container maxWidth="lg" sx={{ textAlign: 'center', my: 6 }}>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          textTransform: 'uppercase', 
          fontWeight: 500,
          mb: 2,
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.2rem',
          letterSpacing: '0.02em',
        }}
      >
        {searchDescription.title}
      </Typography>
      <Typography 
        variant="subtitle1" 
        gutterBottom 
        sx={{ 
          margin: '0 auto', 
          mb: 2,
          color: 'text.secondary',
          fontSize: '1.1rem'
        }}
      >
        {searchDescription.subtitle}
      </Typography>
      <Typography 
        variant="body2" 
        paragraph 
        sx={{ 
          margin: '0 auto',
          color: 'text.secondary',
          fontSize: '0.9rem'
        }}
      >
        {searchDescription.description}
      </Typography>
    </Container>
  );
};

export default SearchDescription;
